import { EmailTemplate } from '../types/email';

export const emailTemplates: EmailTemplate[] = [
  {
    id: '1',
    name: 'Due Diligence Request',
    subject: 'Due Diligence Documentation Request - [Company Name]',
    content: `Dear [Name],

As part of our ongoing due diligence process, we kindly request the following documentation:

1. Financial Information
   - Audited financial statements (last 3 years)
   - Current year monthly financials
   - Cash flow projections
   - Working capital analysis

2. Corporate Documents
   - Certificate of incorporation
   - Bylaws and amendments
   - Board meeting minutes
   - Shareholder agreements

3. Operational Information
   - Organization chart
   - Employee roster
   - Key customer contracts
   - Supplier agreements

Please provide these documents through our secure data room by [Date].

Best regards,
[Your Name]`
  },
  {
    id: '2',
    name: 'Meeting Follow-up',
    subject: 'Follow-up: [Meeting Topic] Discussion',
    content: `Dear [Name],

Thank you for your time today. Here's a summary of our discussion:

Key Points Discussed:
1. [Point 1]
2. [Point 2]
3. [Point 3]

Next Steps:
- [Action item 1] - Due [Date]
- [Action item 2] - Due [Date]
- [Action item 3] - Due [Date]

Please let me know if you have any questions or need clarification.

Best regards,
[Your Name]`
  },
  {
    id: '3',
    name: 'LOI Template',
    subject: 'Letter of Intent - [Deal Name]',
    content: `Dear [Name],

On behalf of [Acquiring Company], I am pleased to present this Letter of Intent for the acquisition of [Target Company].

Key Terms:
1. Purchase Price: [Amount]
2. Payment Terms: [Terms]
3. Due Diligence Period: [Duration]
4. Exclusivity Period: [Duration]

Key Conditions:
1. Satisfactory completion of due diligence
2. Board approval
3. Regulatory clearance
4. Definitive agreement execution

This LOI is non-binding except for the exclusivity and confidentiality provisions.

Please indicate your acceptance by signing below.

Best regards,
[Your Name]`
  }
];